
export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-user-location-line',
      title: 'Potential Customer Visit',
      description: 'Connect with potential customers and partners through organized visits and networking events to establish meaningful business relationships in the US market.'
    },
    {
      icon: 'ri-building-line',
      title: 'US Office Space with Conference Room and Meeting Room',
      description: 'Access fully equipped office spaces with professional conference and meeting rooms for client presentations, team meetings, and business operations.'
    },
    {
      icon: 'ri-mail-line',
      title: 'Virtual Mail Service',
      description: 'Professional US business address with mail forwarding services to establish your company presence and handle important business correspondence.'
    },
    {
      icon: 'ri-shield-user-line',
      title: 'Partners with Insurance and Accountants for Business Setup',
      description: 'Work with our trusted network of insurance providers and certified accountants to ensure proper business registration, compliance, and financial management.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our Platform?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide comprehensive services to help Taiwanese businesses successfully enter and establish themselves in the US market.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
